import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { Home as HomeIcon } from '@mui/icons-material';
import { Box, Breadcrumbs, Typography } from '@mui/material';
import useHasActiveFeatureFlag from '../hooks/useFeatureFlags';
import { FF_SITE_GOALS } from '../components/FeatureFlagWrapper';
import { fetchSiteGoals } from '../actions/siteGoals';
import {
  StyledRescuerBreadcrumb,
  StyledRescuerTextBreadcrumb,
} from '../pages/rescuerDashboard/rescuerDashboardMobile/Components/StyledRescuerBreadcrumb';
import routes from '../routes';
import { siteGoalsJsx } from '../pages/rescuerDashboard/rescuerDashboardDesktop/myFrus/Components/MySiteGoals';

const GoalsBreadcrumb = () => (
  <Box boxShadow={0}>
    <Breadcrumbs aria-label="breadcrumb">
      <StyledRescuerBreadcrumb
        component={RouterLink}
        to={routes.index}
        label="Home"
        icon={<HomeIcon style={{ color: '#fff' }} fontSize="small" />}
      />
      <StyledRescuerTextBreadcrumb component="a" href="#" label="Site Goals" />
    </Breadcrumbs>
  </Box>
);

const SiteGoalsDashboardMobileContainer = () => {
  const goalsEntities = useSelector((state) => state.entities.siteGoals.byId);
  const siteId = useSelector((state) => state.app.site.id);
  const dispatch = useDispatch();
  const hasActiveSiteGoalsFeatureFlag = useHasActiveFeatureFlag(FF_SITE_GOALS);
  const goalsList = Object.values(goalsEntities);

  useEffect(() => {
    if (hasActiveSiteGoalsFeatureFlag) {
      dispatch(fetchSiteGoals({ sites_ids: siteId }));
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <GoalsBreadcrumb />
      <Box
        sx={{
          height: 'calc(100vh - 100px)', // -100 to remove navbar & breadcrumbs
          overflow: 'scroll',
          '&&::-webkit-scrollbar': {
            WebkitAppearance: 'none',
            width: 7,
          },
          '&&::-webkit-scrollbar-thumb': {
            borderRadius: 4,
            backgroundColor: 'rgba(0, 0, 0, .5)',
            WebkitBoxShadow: '0 0 1px rgba(255, 255, 255, .5)',
          },
        }}
      >
        {goalsList < 1 && (
          <Box
            sx={{
              position: 'absolute',
              left: '50%',
              top: '50%',
              WebkitTransform: 'translate(-50%, -50%)',
              transform: 'translate(-50%, -50%)',
              textAlign: 'center',
            }}
          >
            <Typography color="textSecondary" variant="h5">
              There are no site goals set for your site(s).
            </Typography>
          </Box>
        )}
        <Box display="flex" flexWrap="wrap" columnGap="5px" rowGap="5px" px="5px" overflow="scroll">
          {siteGoalsJsx({ siteGoals: goalsList, rowGap: '12px' })}
        </Box>
      </Box>
    </>
  );
};

export default SiteGoalsDashboardMobileContainer;
